import { useTranslation } from "react-i18next";
import ArrowIcon from "@/assets/svgs/arrow";
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Page5 from "./page5";
import { useEffect, useState } from "react";
import { useAppSelector } from "@quest/hooks";
import { useSkipTutorial } from "@/shared/assignments/hooks";

function OnboardingTutorial() {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(1);

  const { t } = useTranslation("New");
  const { idpId, has_skipped_tutorial } = useAppSelector((state) => state.auth);
  const skipTutorial = useSkipTutorial();

  useEffect(() => {
    if (!has_skipped_tutorial) {
      setIsOpen(true);
    }
  }, [has_skipped_tutorial]);

  const handleSkip = () => {
    skipTutorial.mutate(idpId, {
      onSuccess: () => {
        window.location.reload();
      },
    });
  };

  const handleNext = () => {
    if (step === 5) {
      handleSkip();
      return;
    }
    setStep(step + 1);
  };

  function renderStep() {
    const pages = [Page1, Page2, Page3, Page4, Page5];
    const Component = pages[step - 1];
    return (
      <div className="relative w-full" key={`step-${step}`}>
        <Component />
      </div>
    );
  }

  function renderTitle() {
    switch (step) {
      case 1:
        return t("onboardingTitle1");
      case 2:
        return t("onboardingTitle2");
      case 3:
        return t("onboardingTitle3");
      case 4:
        return t("onboardingTitle4");
      case 5:
        return t("onboardingTitle5");
    }
  }

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4">
          <div className="bg-[#EBEBEB] max-h-[90vh]  w-full max-w-[700px] rounded-2xl  p-6 sm:p-10 block flex-col gap-6 sm:gap-10 justify-center items-center overflow-y-auto">
            {/* Title */}
            <p className="text-xl sm:text-2xl font-bold text-center leading-snug">
              {renderTitle()}
            </p>

            {/* Step content */}
            <div className="relative w-full">{renderStep()}</div>

            {/* Footer actions */}
            <div className="flex flex-col sm:flex-row justify-between items-center w-full gap-4 sm:gap-0">
              {step !== 5 && (
                <p
                  className="text-sm font-bold cursor-pointer hover:underline"
                  onClick={handleSkip}
                >
                  {t("skip")}
                </p>
              )}

              <button
                data-testid="next-button"
                className="flex items-center font-bold text-sm"
                onClick={handleNext}
              >
                {step === 5 ? t("done") : t("next")}
                <div className="bg-secondary hover:bg-primary transition-all duration-300 ml-3 rounded-full w-10 h-10 flex items-center justify-center">
                  <ArrowIcon />
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OnboardingTutorial;
